import { FC } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/components/SideBarDireita/SideBarDireita.css'
import { MenuProfileDireita } from '../Sidebar/styled'

export const NavDireita: FC = () => {
  const permissoes = localStorage.getItem('permissoes')
  let permissao = []
  if (permissoes) {
    permissao = JSON.parse(permissoes)
  } else {
    permissao = [
      {
        perModulo: 'ACECAD',
        perAcesso: 1
      },
      {
        perModulo: 'ACELOC',
        perAcesso: 1
      },
      {
        perModulo: 'ACEPES',
        perAcesso: 1
      },
      {
        perModulo: 'ACEAUD',
        perAcesso: 1
      },
      {
        perModulo: 'ACETXT',
        perAcesso: 1
      },
      {
        perModulo: 'ACEUNI',
        perAcesso: 1
      },
      {
        perModulo: 'ACEGPU',
        perAcesso: 1
      },
      {
        perModulo: 'ACEFUN',
        perAcesso: 1
      },
      {
        perModulo: 'ACEREL',
        perAcesso: 1
      },
      {
        perModulo: 'ACETPD',
        perAcesso: 1
      },
      {
        perModulo: 'ACEDOC',
        perAcesso: 1
      }
    ]
  }
  let ACECAD = permissao.find((element: any) => {
    return element.perModulo === 'ACECAD'
  })
  let ACELOC = permissao.find((element: any) => {
    return element.perModulo === 'ACELOC'
  })
  let ACEPES = permissao.find((element: any) => {
    return element.perModulo === 'ACEPES'
  })
  let ACEAUD = permissao.find((element: any) => {
    return element.perModulo === 'ACEAUD'
  })
  // let ACETXT = permissao.find((element: any) => {
  //   return element.perModulo === 'ACETXT'
  // })
  // let ACEUNI = permissao.find((element: any) => {
  //   return element.perModulo === 'ACEUNI'
  // })
  // let ACEGPU = permissao.find((element: any) => {
  //   return element.perModulo === 'ACEGPU'
  // })
  // let ACEFUN = permissao.find((element: any) => {
  //   return element.perModulo === 'ACEFUN'
  // })
  // let ACEREL = permissao.find((element: any) => {
  //   return element.perModulo === 'ACEREL'
  // })
  // let ACETPD = permissao.find((element: any) => {
  //   return element.perModulo === 'ACETPD'
  // })
  let ACEDOC = permissao.find((element: any) => {
    return element.perModulo === 'ACEDOC'
  })
  return (
    <MenuProfileDireita>
      <ul className="UlMenuProfileDireita">
        {!!ACECAD.perAcesso ? (
          <li>
            <Link to="/FormularioCadastro">
              <button className="ttlBtnNav1">Dados Cadastrais</button>
            </Link>
          </li>
        ) : (
          <li></li>
        )}
        {!!ACELOC.perAcesso ? (
          <li>
            <Link to="/Locais">
              <button className="ttlBtnNav2">Locais</button>
            </Link>
          </li>
        ) : (
          <li></li>
        )}
        {!!ACEPES.perAcesso ? (
          <li>
            <Link to="/Pessoas">
              <button className="ttlBtnNav3">Pessoas</button>
            </Link>
          </li>
        ) : (
          <li></li>
        )}
        {!!ACEAUD.perAcesso ? (
          <li>
            <Link to="/Relatorio">
              <button className="ttlBtnNav4">Auditoria</button>
            </Link>
          </li>
        ) : (
          <li></li>
        )}
        {!!ACEDOC.perAcesso ? (
          <li>
            <Link to="/Documentos">
              <button className="ttlBtnNav5">Documentos</button>
            </Link>
          </li>
        ) : (
          <li></li>
        )}
      </ul>
    </MenuProfileDireita>
  )
}
